import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { GetUserDetail_user } from '../../user-details/queries/generated/GetUserDetail';
import * as UserPreferenceDetailActions from './user-preference-detail.actions';

export const userPreferenceDetailFeatureKey = 'userPreferenceDetail';

export interface State {
   user: GetUserDetail_user | null;
   callState: CallState;
}

export const initialState: State = {
   callState: LoadingState.Init,
   user: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(
      UserPreferenceDetailActions.loadUser,
      UserPreferenceDetailActions.saveUserPreferenceDetail,
      UserPreferenceDetailActions.loadCurrentUserId,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loading,
         };
      }
   ),
   on(UserPreferenceDetailActions.loadUserSuccess, (state, action) => {
      return {
         ...state,
         user: action.user,
         callState: LoadingState.Loaded,
      };
   }),
   on(UserPreferenceDetailActions.saveUserPreferenceDetailSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);
